import { gql } from '@apollo/client';

export const userDetails = gql`
  fragment userDetails on Candidate {
    _id
    emailAddress
    trackingId
    personalDetails {
      firstName
      lastName
    }
  }
`;

export const GET_USER = gql`
  query GetUser {
    viewer {
      ...userDetails
    }
  }
  ${userDetails}
`;
